export const renderImgSrc = (imgSrc, name) => {
    if(imgSrc){
        return `data:image/png;base64,${imgSrc}`
    }
    return `https://ui-avatars.com/api/?name=${name}&background=e8eaff&color=2c25c4`
}